/* eslint-disable no-console */
import axios from 'axios';
import { getCookie } from './cookies';

/**
 * Request Wrapper with default success/error actions
 */

const request = options => {
    /**
     * Create an Axios Client with defaults
     */

    const axiosOptions = {
        baseURL: 'https://app.hamyarsystem.com/rest/'
    };

    let auth = null;

    if (getCookie('auth')) {
        auth = JSON.parse(getCookie('auth'));
    }

    if (auth) {
        axiosOptions.headers = {
            Authorization: `Bearer ${auth.token}`
        };
    }

    const client = axios.create(axiosOptions);

    const onSuccess = response => {
        return response.data;
    };

    const onError = error => {
        if (error.response) {
            // Request was made but server responded with something
            // other than 2xx
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data);
            console.error('Headers:', error.response.headers);
        } else {
            // Something else happened while setting up the request
            // triggered the error
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    };
    return client(options)
        .then(onSuccess)
        .catch(onError);
};

export default request;
